import React from 'react';
import { Typography } from 'glints-aries/lib/@next';
import { Neutral } from 'glints-aries/lib/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';

import * as S from 'src/modules/Opportunity/Components/Benefits.sc';

import { JobBenefitType } from '../interface';

interface Props {
  benefits: JobBenefitType[];
}

export const Benefits: React.FC<React.PropsWithChildren<Props>> = ({
  benefits,
}) => {
  return (
    <>
      <FormattedMessage
        id="text-job-benefits"
        defaultMessage="Job Benefits"
        tagName={S.Title}
      />
      <S.TagContainer>
        {benefits.map(({ title, benefit }) => (
          <S.TagOverride key={`${benefit}_${title}`}>
            <Typography variant="subtitle2" color={Neutral.B18}>
              {title}
            </Typography>
          </S.TagOverride>
        ))}
      </S.TagContainer>
    </>
  );
};
